<div
  class="section"
  [style.backgroundColor]="backgroundColor()"
  [style.color]="textColor()"
  [style.textAlign]="textAlign()"
>
  @if(title()){
  <h1>{{ title() }}</h1>
  } 
  @if(sectionConfig().descriptionBlock){
    <lsa-description-block
      [descriptionBlockConfig]="sectionConfig().descriptionBlock!">
    </lsa-description-block>
  } 
  @if(sectionConfig().verseOfTheDay?.copyright){
    <lsa-verse-of-the-day
      [config]="sectionConfig().verseOfTheDay!">
    </lsa-verse-of-the-day>
  } 
  @if(sectionConfig().mapWidget?.src){    
    <lsa-map-widget [config]="sectionConfig().mapWidget!"></lsa-map-widget>
  } 
  @if (sectionConfig().imageCard?.image){
    <lsa-image-card [config]="sectionConfig().imageCard!"></lsa-image-card>
  } 
  @if(sectionConfig().quickLinks?.links && sectionConfig().quickLinks?.links!.length > 0 )
  {
    <lsa-quick-links [config]="sectionConfig().quickLinks!"></lsa-quick-links>
  } 
  @if(sectionConfig().searchBox?.placeHolder){
    <lsa-searchbox [config]="sectionConfig().searchBox!"></lsa-searchbox>
  }
  @if(sectionConfig().preachingPlaylists?.isNullOrEmpty() === false){
    <lsa-preaching-playlists [config]="sectionConfig().preachingPlaylists!" ></lsa-preaching-playlists>
  }
  @if(sectionConfig().recentServices?.isNullOrEmpty() === false) {
    <lsa-recent-services [config]="sectionConfig().recentServices!"></lsa-recent-services>
  }
  @if (sectionConfig().bibleCourses?.isNullOrEmpty() === false) {
    <lsa-bible-courses [config]="sectionConfig().bibleCourses!"></lsa-bible-courses>
  }
  @if(sectionConfig().videoGallery?.show){
    <lsa-video-gallery></lsa-video-gallery>
  }
  @if(sectionConfig().calendarListView?.title){
    <lsa-calendar-list-view [config]="sectionConfig().calendarListView!"></lsa-calendar-list-view>
  }
</div>
